export const map = {
  CASH_EQUITY: "87578c5e-d93c-4100-9f25-1191717661d4",
  BROKER_COMPANY: "04c0503c-a8c3-11e9-8b5f-00ff12c3b408",
  MSA: "04c05043-a8c3-11e9-8b5f-00ff12c3b408",
  HOLD_PERIOD_YEARS: "04c05049-a8c3-11e9-8b5f-00ff12c3b408",
  EXIT_CAP: "04c0504d-a8c3-11e9-8b5f-00ff12c3b408",
  LOAN_BALANCE_AT_EXIT: "7d8f26a7-3f5e-11e9-bf92-0242ac140002",
  PREPAYMENT: "7d8f271a-3f5e-11e9-bf92-0242ac140002",
  STATE: "7d8f278f-3f5e-11e9-bf92-0242ac140002",
  CITY: "7d8f28d8-3f5e-11e9-bf92-0242ac140002",
  ASSET_CLASS: "7d8f2a18-3f5e-11e9-bf92-0242ac140002",
  ASSET_TYPE: "7d8f2a95-3f5e-11e9-bf92-0242ac140002",
  SALES_PRICE: "7d8f2af8-3f5e-11e9-bf92-0242ac140002",
  EXIT_DATE: "7d8f2b5e-3f5e-11e9-bf92-0242ac140002"
};
export const list = Object.values(map);
export default {
  map,
  list
};
